import React from 'react';
import CourseWorkspaceQuiz from '~/components/courses/course-workspace-quiz';

/**
 * Footer section for our course builder. Contains the Final Quizzes section
 */
const CourseBuilderFooter = () => (
	<footer className="ld__builder--footer">
		<CourseWorkspaceQuiz />
	</footer>
);

export default CourseBuilderFooter;
